import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/45b021a8/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Thanks for completing the IBM Carbon tutorial and helping us improve it along the way. If you want to show the world your new skills, you can apply for an IBM Digital Badge.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Application form</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Badge information</AnchorLink>
    </AnchorLinks>
    <h2>{`Application form`}</h2>
    <p>{`Once you complete all five steps of the tutorial, you can apply for an `}<a parentName="p" {...{
        "href": "https://www.surveygizmo.com/s3/5163103/IBM-Carbon-Design-System-Developer-Essentials-React-v2"
      }}>{`IBM Digital Badge`}</a>{`. These badges are available to anybody — not just IBM employees.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.04347826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABG0lEQVQoz6WSzUrDQBDH+xA+gk+hnsRX8HE86cmTCrZ660HwBeoHIkXBeBAq1DSgQRDRmphNk0zYTTb7MTEm4CnGFOc07M7vP7Oz/07+a2D+V3Qab7FZpR7WqLiCRAVCM2wPF6WJjKgkLAOWUiZCKojQSStYoUD8buWT2H6cZlyWh7KYpQmuxrsnx8P37Vv30HAPDLd343SL/OJtc8rGZY2ugSsSUfef1rdGi/vW6q65vGeudK21HXNp427BcHrVLmo7YyU8MPsTcvbgnkzIqeWfj92BHVxevxyNXq9KWDe9OaY8oSjT/PMjerYdzlSRQ5zxTLTaNjDwIm8GQQihDz4BL82Sef5Z64iCDzOasvkc9uMK/J89c2xU+AIyzezUfsst8gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "carbon badge",
            "title": "carbon badge",
            "src": "/static/df7d368937a22295b5c5039e9882a683/3cbba/carbon-badge.png",
            "srcSet": ["/static/df7d368937a22295b5c5039e9882a683/7fc1e/carbon-badge.png 288w", "/static/df7d368937a22295b5c5039e9882a683/a5df1/carbon-badge.png 576w", "/static/df7d368937a22295b5c5039e9882a683/3cbba/carbon-badge.png 1152w", "/static/df7d368937a22295b5c5039e9882a683/392b1/carbon-badge.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">IBM Digital Badge</Caption>
      </Column>
    </Row>
    <p>{`Once you submit the application, please allow a few weeks for issuing the badge. Once the badge is issued, you will be notified and must accept the badge via Acclaim.`}</p>
    <h2>{`Badge information`}</h2>
    <h3>{`IBM Design System React Components`}</h3>
    <p>{`This badge demonstrates knowledge about Carbon’s React components. To earn the badge:`}</p>
    <ol>
      <li parentName="ol">{`Complete steps 1 through 5 of the Carbon React tutorial`}<ul parentName="li">
          <li parentName="ul">{`Step 1. `}<a parentName="li" {...{
              "href": "/tutorial/react/step-1"
            }}>{`Installing Carbon`}</a></li>
          <li parentName="ul">{`Step 2. `}<a parentName="li" {...{
              "href": "/tutorial/react/step-2"
            }}>{`Building pages`}</a></li>
          <li parentName="ul">{`Step 3. `}<a parentName="li" {...{
              "href": "/tutorial/react/step-3"
            }}>{`Using APIs`}</a></li>
          <li parentName="ul">{`Step 4. `}<a parentName="li" {...{
              "href": "/tutorial/react/step-4"
            }}>{`Creating components`}</a></li>
          <li parentName="ul">{`Step 5. `}<a parentName="li" {...{
              "href": "/tutorial/react/step-5"
            }}>{`Deploying to IBM Cloud`}</a></li>
        </ul></li>
      <li parentName="ol">{`Have approved pull requests for steps 1 through 5 in the `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-tutorial"
        }}>{`carbon-tutorial repository`}</a></li>
      <li parentName="ol">{`Complete the `}<a parentName="li" {...{
          "href": "https://www.surveygizmo.com/s3/5163103/IBM-Carbon-Design-System-Developer-Essentials-React-v2"
        }}>{`badge application`}</a></li>
    </ol>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` To quickly find your submitted PRs, you can `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-tutorial/pulls?utf8=%E2%9C%93&q=author%3Ausername"
        }}>{`filter by author`}</a>{` (e.g. `}<inlineCode parentName="p">{`author:\${username}`}</inlineCode>{`).`}</p>
    </InlineNotification>
    <h3>{`FAQ and help`}</h3>
    <p>{`Badge issuer contact: matt.rosno@ibm.com`}</p>
    <p>{`For questions related to your Acclaim badge earner account and profile, as well as issues related to claiming your badge after receiving a notification, go to `}<a parentName="p" {...{
        "href": "http://support.youracclaim.com"
      }}>{`http://support.youracclaim.com`}</a>{` for account issues.`}</p>
    <h3>{`Privacy statement`}</h3>
    <p>{`NOTICE: IBM leverages the services of Credly’s Acclaim platform, a 3rd party data processor authorized by IBM and located in the United States, to assist in the administration of the IBM Digital Badge program. In order to issue you an IBM Digital Badge, your personal information (name, email address, and badge earned) will be shared with the Credly’s Acclaim platform. You will receive an email notification from Acclaim with instructions for claiming the badge. Your personal information is used to issue your badge and for program reporting and operational purposes. It will be handled in a manner consistent with IBM privacy practices. The IBM Privacy Statement can be viewed here: `}<a parentName="p" {...{
        "href": "https://www.ibm.com/privacy/us/en/"
      }}>{`https://www.ibm.com/privacy/us/en/`}</a>{`. IBM employees can view the IBM Internal Privacy Statement here: `}<a parentName="p" {...{
        "href": "https://w3.ibm.com/w3publisher/w3-privacy-notice"
      }}>{`https://w3.ibm.com/w3publisher/w3-privacy-notice`}</a>{`.`}</p>
    <h3>{`Application form`}</h3>
    <p>{`To apply for the IBM Digital Badge, please complete the `}<a parentName="p" {...{
        "href": "https://www.surveygizmo.com/s3/5163103/IBM-Carbon-Design-System-Developer-Essentials-React-v2"
      }}>{`form and survey`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      